"use strict";

function equalizer() {
  var max = -1;

  // Equalize .height-equal
  $(".height-equal").css("min-height", "auto");
  $(".height-equal").each(function () {
    var minHeight = $(this).outerHeight();
    max = minHeight > max ? minHeight : max;
  });
  $(".height-equal").css("min-height", max);

  if ($(window).width() <= 767) {
    $(".height-equal").css("min-height", "auto");
  }

  // Equalize .height-equal-2
  $(".height-equal-2").css("min-height", "auto");
  $(".height-equal-2").each(function () {
    var minHeight = $(this).outerHeight();
    max = minHeight > max ? minHeight : max;
  });
  $(".height-equal-2").css("min-height", max);

  if ($(window).width() <= 767) {
    $(".height-equal-2").css("min-height", "auto");
  }
}

// Use ResizeObserver for modern browsers
function setupResizeObserver() {
  if (typeof ResizeObserver !== "undefined") {
    const elementsToObserve = document.querySelectorAll(".height-equal, .height-equal-2");
    const observer = new ResizeObserver(() => {
      equalizer();
    });

    elementsToObserve.forEach((element) => {
      observer.observe(element);
    });
  } else {
    console.warn("ResizeObserver is not supported in this browser.");
  }
}

// Document Ready
document.addEventListener("DOMContentLoaded", function () {
  (function ($) {
    "use strict";

    // Initial equalizer
    equalizer();

    // Set up ResizeObserver
    setupResizeObserver();

    // Fallback: jQuery resize event
    $(window).resize(function () {
      equalizer();
    });
  })(jQuery);
});
